import { createFileRoute, Link, Outlet, useRouterState } from '@tanstack/react-router'

import { ResearchBarFormShell } from '@/components/research-bar/research-bar-form-shell'

export const Route = createFileRoute('/research-bar')({
  component: ResearchBarComponent,
})

function ResearchBarComponent() {
  const pathname = useRouterState({
    select: (state) => state.location.pathname,
  })

  if (pathname !== '/research-bar') {
    return <Outlet />
  }

  return (
    <div className="bg-brand-50 flex min-h-screen min-w-screen flex-1 flex-col items-center justify-center gap-5 bg-[url('/images/default-background.jpg')] bg-cover bg-center bg-no-repeat">
      <ResearchBarFormShell />
      <div className="text-sm font-medium text-white">ou</div>
      <Link
        className="rounded-md border-2 border-white px-12 py-4 text-white hover:underline hover:underline-offset-2"
        to="/estimate"
      >
        <div className="font-semibold text-white">Faire un devis sur mesure</div>
      </Link>
      <span className="text-sm font-medium text-white">
        (Congés Bonifiés, UM, Groupes, Plusieurs départs, Demandes particulières…)
      </span>
    </div>
  )
}
